var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('bottom-sheet', _vm._b({
    attrs: {
      "fullscreen": "",
      "persistent": "",
      "width": "1224"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(bind) {
        return [_vm._t("activator", null, null, bind)];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, 'bottom-sheet', {
    title: _vm.title
  }, false), [_c('v-layout', {
    staticClass: "bottom-sheet__contents",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('v-expansion-panels', {
    attrs: {
      "flat": "",
      "accordion": ""
    },
    model: {
      value: _vm.section,
      callback: function callback($$v) {
        _vm.section = $$v;
      },
      expression: "section"
    }
  }, [_vm._l(_vm.sections, function (_ref, index) {
    var text = _ref.text,
      value = _ref.value;
    return [_c('v-expansion-panel', {
      key: value
    }, [_c('v-expansion-panel-header', [_c('v-row', {
      staticClass: "row--small page-text--lg font-weight-bold"
    }, [_c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('span', {
      staticClass: "primary--active"
    }, [_vm._v(_vm._s((index + 1).toString().padStart(2, 0)))])]), _c('v-col', [_vm._v(" " + _vm._s(text) + " ")])], 1)], 1), _c('v-expansion-panel-content', [value == _vm.RECRUITMENT_FORM_SECTIONS.BASEINFO.value ? [_c('form-baseinfo', _vm._b({
      key: "".concat(value),
      model: {
        value: _vm.form,
        callback: function callback($$v) {
          _vm.form = $$v;
        },
        expression: "form"
      }
    }, 'form-baseinfo', {
      hashTags: _vm.hashTags
    }, false))] : _vm._e(), value == _vm.RECRUITMENT_FORM_SECTIONS.EMPLOYMENT.value ? [_c('form-employment', {
      key: "".concat(value),
      model: {
        value: _vm.form,
        callback: function callback($$v) {
          _vm.form = $$v;
        },
        expression: "form"
      }
    })] : _vm._e(), value == _vm.RECRUITMENT_FORM_SECTIONS.QUALIFICATION.value ? [_c('form-qualification', {
      key: "".concat(value),
      model: {
        value: _vm.form,
        callback: function callback($$v) {
          _vm.form = $$v;
        },
        expression: "form"
      }
    })] : _vm._e(), value == _vm.RECRUITMENT_FORM_SECTIONS.RECRUITER.value ? [_c('form-recruiter', {
      key: "".concat(value),
      model: {
        value: _vm.form,
        callback: function callback($$v) {
          _vm.form = $$v;
        },
        expression: "form"
      }
    })] : _vm._e(), value == _vm.RECRUITMENT_FORM_SECTIONS.QUESTIONS.value ? [_c('form-questions', {
      key: "".concat(value),
      model: {
        value: _vm.form.questions,
        callback: function callback($$v) {
          _vm.$set(_vm.form, "questions", $$v);
        },
        expression: "form.questions"
      }
    })] : _vm._e()], 2), _c('v-divider', {
      staticClass: "my-10 my-lg-18"
    })], 1)];
  })], 2), _c('div', {
    staticClass: "v-btn-group flex-wrap"
  }, [_c('form-preview', {
    attrs: {
      "recruitment": _vm.form
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var attrs = _ref2.attrs,
          on = _ref2.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "min-w-140px min-w-lg-160px",
          attrs: {
            "outlined": "",
            "color": "grey-d"
          }
        }, 'v-btn', attrs, false), on), [_c('span', {
          staticClass: "grey-6--text"
        }, [_vm._v("미리보기")])])];
      }
    }])
  }), _c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', [_vm._v("저장하기")])])], 1), _c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "light": "",
      "color": "white"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": "100",
      "width": "5",
      "color": "primary",
      "indeterminate": ""
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }